// services/chatService.js

import api from "../api/axiosInstance";



// ✅ CREATE CONVERSATION
export const createConversation = async (
  fromProfileId,
  toProfileId
) => {
  try {
    console.log("fromProfileId:", fromProfileId);
    console.log("toProfileId:", toProfileId);

    const response = await api.post(
      "/chat/conversation",
      {
        fromProfileId,
        toProfileId,
      }
    );

    console.log(
      "✅ CREATE CONVERSATION RESPONSE:",
      response.data
    );

    return response.data;
  } catch (error) {
    console.log(
      "CREATE CONVERSATION ERROR:",
      error.response?.data || error
    );

    return null;
  }
};



// ✅ SEND MESSAGE
export const sendChatMessage = async (
  conversationId,
  text
) => {
  try {
    const res = await api.post(
      "/chat/message",
      {
        conversationId,
        text,
      }
    );

    return res.data;
  } catch (err) {
    console.error(err);

    throw err;
  }
};



// ✅ GET MESSAGES
export const getMessages = async (
  conversationId
) => {
  try {
    const token =
      localStorage.getItem("token");

    const response = await api.get(
      `/chat/messages/${conversationId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log(
      "✅ GET MESSAGES RESPONSE:",
      response.data
    );

    return (
      response.data.messages || []
    );

  } catch (err) {
    console.error(err);

    return [];
  }
};